import { Component } from "@angular/core";

@Component({
  selector: "configuration-area-wrapper",
  templateUrl: "./wrapper.component.html",
  styleUrls: ["./wrapper.component.scss"]
})
export class ConfigurationAreaWrapperComponent {}
